// extracted by mini-css-extract-plugin
export var contentBody = "_4m-9";
export var headerImage = "_4m-2";
export var imageButton = "_4m-7";
export var imageButtonIcon = "_4m-8";
export var imageHeader = "_4m-4";
export var imageHeaderText = "_4m-5";
export var imageOverlay = "_4m-3";
export var imageTitle = "_4m-6";
export var imageWrapper = "_4m-1";
export var taskList = "_4m-a";
export var widget = "_4m-0";